/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Download_ButtonInputs */

const en_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Desktop App`)
};

const fr_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger l'Application de Bureau`)
};

const de_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop-App herunterladen`)
};

const it_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica l'app desktop`)
};

const ru_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать настольное приложение`)
};

const es_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar la aplicación de escritorio`)
};

const zh_cn2_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载桌面应用程序`)
};

const ja_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップアプリをダウンロード`)
};

const hi_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेस्कटॉप ऐप डाउनलोड करें`)
};

const pt_pt2_desktop_banner_download_button = /** @type {(inputs: Desktop_Banner_Download_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe o aplicativo para desktop`)
};

/**
* | output |
* | --- |
* | "Download Desktop App" |
*
* @param {Desktop_Banner_Download_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_download_button = /** @type {((inputs?: Desktop_Banner_Download_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Download_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_desktop_banner_download_button(inputs)
	if (locale === "de") return de_desktop_banner_download_button(inputs)
	if (locale === "it") return it_desktop_banner_download_button(inputs)
	if (locale === "ru") return ru_desktop_banner_download_button(inputs)
	if (locale === "es") return es_desktop_banner_download_button(inputs)
	if (locale === "zh-CN") return zh_cn2_desktop_banner_download_button(inputs)
	if (locale === "ja") return ja_desktop_banner_download_button(inputs)
	if (locale === "hi") return hi_desktop_banner_download_button(inputs)
	if (locale === "pt-PT") return pt_pt2_desktop_banner_download_button(inputs)
	return en_desktop_banner_download_button(inputs)
});